import * as ActionTypes from '../ActionTypes';

const initialState = {
    error: null,
    manageGoalLoading: false,
    goalData: [],
    MyGoalLoading: false,
    myGoalData: [],
    logLoading: false,
    performanceLogData: []
   
};

export const ManageGoalReducer = (state = initialState, action) => {
    switch (action.type) {  
        case ActionTypes.MANAGE_GOAL_GET_REQUEST:
            return {
                ...state,
                manageGoalLoading: true,
                goalData: [],
                error: null,
            }
        case ActionTypes.MANAGE_GOAL_ADD_REQUEST:
        case ActionTypes.MANAGE_GOAL_UPDATE_REQUEST:
        case ActionTypes.MANAGE_GOAL_DELETE_REQUEST:
            return {
                ...state,
                manageGoalLoading: true,
                error: null,
            };

        case ActionTypes.MANAGE_GOAL_GET_SUCCESS:
            return {
                ...state,
                manageGoalLoading: false,
                goalData: action.payload?.data?.data,
                error: null,
            };
        case ActionTypes.MANAGE_GOAL_ADD_SUCCESS:
        case ActionTypes.MANAGE_GOAL_UPDATE_SUCCESS:
        case ActionTypes.MANAGE_GOAL_DELETE_SUCCESS:
            return {
                ...state,
                manageGoalLoading: false,
                // goalData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.MANAGE_GOAL_GET_ERROR:
        case ActionTypes.MANAGE_GOAL_ADD_ERROR:
        case ActionTypes.MANAGE_GOAL_UPDATE_ERROR:
        case ActionTypes.MANAGE_GOAL_DELETE_ERROR:
            return {
                ...state,
                manageGoalLoading: false,
                error: true,
            };
        case ActionTypes.MY_GOAL_GET_REQUEST:
            return {
                ...state,
                MyGoalLoading: true,
                myGoalData: [],
                error: null,
            }
        case ActionTypes.MY_GOAL_GET_SUCCESS:
            return {
                ...state,
                MyGoalLoading: false,
                myGoalData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.MY_GOAL_GET_ERROR:
            return {
                ...state,
                MyGoalLoading: false,
                error: true,
            };
        case ActionTypes.PERFORMANCE_LOG_GET_REQUEST:
            return {
                ...state,
                logLoading: true,
                performanceLogData: [],
                error: null,
            }
        case ActionTypes.PERFORMANCE_LOG_ADD_REQUEST:
        case ActionTypes.PERFORMANCE_LOG_UPDATE_REQUEST:
        case ActionTypes.PERFORMANCE_LOG_DELETE_REQUEST:
            return {
                ...state,
                logLoading: true,
                error: null,
            };

        case ActionTypes.PERFORMANCE_LOG_GET_SUCCESS:
        case ActionTypes.PERFORMANCE_LOG_ADD_SUCCESS:
        case ActionTypes.PERFORMANCE_LOG_UPDATE_SUCCESS:
        case ActionTypes.PERFORMANCE_LOG_DELETE_SUCCESS:
            return {
                ...state,
                logLoading: false,
                performanceLogData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.PERFORMANCE_LOG_GET_ERROR:
        case ActionTypes.PERFORMANCE_LOG_ADD_ERROR:
        case ActionTypes.PERFORMANCE_LOG_UPDATE_ERROR:
        case ActionTypes.PERFORMANCE_LOG_DELETE_ERROR:
            return {
                ...state,
                logLoading: false,
                error: true,
            };
        default:
            return state;
    }
};
